import React from 'react';
import TextField from 'material-ui/TextField';
import withValidations from './withValidations';
import { isNotEmpty } from './validations';


const ValidatedTextField = withValidations(TextField, isNotEmpty);

export default ValidatedTextField;


// WEBPACK FOOTER //
// ./components/forms/ValidatedTextField.js